export function changeHistoricLoading(loading){
    return{
        type: 'changeHistoricLoading',
        info: "changeHistoricLoading",
        payload: { loading: loading }
    }
}

export function changeHistoricLoadingList(loading){
    return{
        type: 'changeHistoricLoadingList',
        info: "changeHistoricLoadingList",
        payload: { loading: loading }
    }
}

export function changeHistoricListData(data){
    return{
        type: 'changeHistoricListData',
        info: "changeHistoricListData",
        payload: { data: data }
    }
}

export function changeHistoricGraphData(data){
    return{
        type: 'changeHistoricGraphData',
        info: "changeHistoricGraphData",
        payload: { data: data }
    }
}

export function changeHistoricListTitles(titles){
    return{
        type: 'changeHistoricListTitles',
        info: "changeHistoricListTitles",
        payload: { titles: titles }
    }
}

export function changeHistoricPagination(pages){
    return{
        type: 'changeHistoricPagination',
        info: "changeHistoricPagination",
        payload: { pages: pages }
    }
}

export function ChangeAnalysisData(analysisData){
    return{
        type: 'ChangeAnalysisData',
        info: "ChangeAnalysisData",
        payload: { analysisData: analysisData }
    }
}

export function ChangeAllData(listAllData){
    return{
        type: 'ChangeAllData',
        info: "ChangeAllData",
        payload: { listAllData: listAllData }
    }
}

export function ChangeListOperationMode(listOperationMode){
    return{
        type: 'ChangeListOperationMode',
        info: "ChangeListOperationMode",
        payload: { listOperationMode: listOperationMode }
    }
}

export function changeOnlyGraphsData(data){
    return{
        type: 'changeOnlyGraphsData',
        info: "changeOnlyGraphsData",
        payload: { data: data }
    }
}

export function changeOnlyGraphsLoading(loading){
    return{
        type: 'changeOnlyGraphsLoading',
        info: "changeOnlyGraphsLoading",
        payload: { loading: loading }
    }
}

export function changeHistoricCity(city){
    return{
        type: 'changeHistoricCity',
        info: "changeHistoricCity",
        payload: { city: city }
    }
}

export function changeHistoricCities(cities){
    return{
        type: 'changeHistoricCities',
        info: "changeHistoricCities",
        payload: { cities: cities }
    }
}

export function changeHistoricEquipamentList(equipamentList){
    return{
        type: 'changeHistoricEquipamentList',
        info: "changeHistoricEquipamentList",
        payload: { equipamentList: equipamentList }
    }
}